import { combineReducers } from 'redux'
import common from "./common"
import auth from "./auth"
import question from "./question"
import baseline from "./baseline"
import dashboard from "./dashboard"
import feedback from "./feedback"

export default combineReducers({
    common,
    auth,
    question,
    baseline,
    dashboard,
    feedback
});
